export default {
	baseURL: 'https://api.ezifood.com/api/v1',
	serviceRates: {
		paid: 0.03,
		free: 0
	}
}



//////////////////
// WEBPACK FOOTER
// ./config/app.js
// module id = 41
// module chunks = 14